import apiCall from "@/api";
import { LOGIN } from "@/api/endpoints";
import router from "@/router";
// import store from "@/store";

const state = {
  token: localStorage.getItem("user-token") || "",
  status: "",
  hasLoadedOnce: false,
};

const getters = {
  isAuthenticated: (state) => !!state.token,
  token: (state) => state.token,
  authStatus: (state) => state.status,
};

const actions = {
  ["AUTH_INIT"]: ({ commit }, callbackUrl) => {
    return new Promise((resolve, reject) => {
      commit("AUTH_INIT");
      apiCall
        .initAuth(callbackUrl)
        .then(function(response) {
          // handle success
          window.location.href = response.data.redirectUrl;
          resolve(response);
        })
        .catch(function(error) {
          // handle error
          console.log(error);
          reject(error);
        })
        .then(function() {
          // always executed
        });
    });
  },
  ["AUTH_REQUEST"]: ({ commit, dispatch }, credentials) => {
    return new Promise((resolve, reject) => {
      commit("AUTH_REQUEST");
      commit("LOGIN_LOADING", true);
      apiCall
        .post(LOGIN, { username: credentials.username, password: credentials.password })
        .then(async function(response) {
            commit("LOGIN_LOADING", false);
          // handle success
          console.log(response);
          if (response.data.data.token) {
            localStorage.setItem("user-token", response.data.data.token);
            commit("AUTH_SUCCESS", response.data.data);
            await dispatch("USER_REQUEST");
            resolve(response);
          } else {
            commit("AUTH_ERROR");
            localStorage.removeItem("user-token");
            reject(response);
            return false;
          }
        })
        .catch(function(error) {
          // handle error
          commit("AUTH_ERROR");
          commit("LOGIN_LOADING", false);
          localStorage.removeItem("user-token");
          reject(error);
          return false;
        })
        .then(() => {
          // always executed
        });
    });
  },
  ["AUTH_LOGOUT"]: ({ commit }) => {
    return new Promise((resolve) => {
      commit("AUTH_LOGOUT");
      localStorage.removeItem("user-token");
      commit("NOT_INITIALIZED");
      let history = router.history;
      router.replace(history.current.path);
      resolve();
    });
  },
};

const mutations = {
  ["AUTH_INIT"]: (state) => {
    state.status = "loading";
  },
  ["LOGIN_LOADING"]: (state, loadingState) => {
    state.loadingState = loadingState;
  },
  ["AUTH_REQUEST"]: (state) => {
    state.status = "loading";
  },
  ["AUTH_SUCCESS"]: (state, resp) => {
    state.status = "success";
    state.token = resp.token;
    state.hasLoadedOnce = true;
  },
  ["AUTH_ERROR"]: (state) => {
    state.status = "error";
    state.hasLoadedOnce = true;
  },
  ["AUTH_LOGOUT"]: (state) => {
    state.token = "";
  },
};

export default {
  state,
  getters,
  actions,
  mutations,
};
